import React, { useState } from "react";
import { Container, Typography, Box, Tabs, Tab, Paper } from "@mui/material";
import AgingDetails from "../Components/Aging"; // Your separate Aging component
import TicketsDetails from "../Components/Tickets"; // Your separate Tickets component
import CriticalJobs from "../Components/CriticalJobs";

function AgingAndTicketsPage() {
  const [activeTab, setActiveTab] = useState(0); // 0 = Tickets, 1 = Aging
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 0 }}>

      <Paper
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="standard"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#1976d2",
              height: 3,
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "16px",
              minWidth: 100,
            },
          }}
        >
          <Tab label="Tickets" />
          <Tab label="Aging" />
          <Tab label="Critical Jobs" />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box>
        {activeTab === 0 && <TicketsDetails />}
        {activeTab === 1 && <AgingDetails />}
         {activeTab === 2 && <CriticalJobs />}
      </Box>
    </Container>
  );
}

export default AgingAndTicketsPage;
